import type { MaterialInfo, PartDefinition } from '@rogue/rackbuilder'
import { AdjustOnlyVisual } from '../../../constants'
import { getRackModel } from '../../../modelPaths'
import { CaveOptions } from '../../../RackTypes'

// Parts for the Fold Back Racks
export class CaveUprightBuilder {
  protected config: CaveOptions
  protected material: MaterialInfo
  protected line: string
  protected height: CaveOptions['height']
  protected uprightMaterial: MaterialInfo

  constructor(config: CaveOptions, material: MaterialInfo) {
    this.config = config
    this.material = material
    this.line = config.line
    this.height = config.height
    this.uprightMaterial = {
      main     : { material: 'mg', color: 'black' },
      hardware : { material: this.config.hardware },
    }
  }

  createFrontStick(left: boolean): PartDefinition {
    const sideTransform = this.getSideTransform(left)

    return {
      mesh      : getRackModel(`CAVE_${this.line}`, `stick numbered ${this.height}`),
      slots     : {},
      materials : this.material,
      ...sideTransform,
    }
  }

  createBackUpright(left: boolean): PartDefinition {
    const sideTransform = this.getSideTransform(left)

    return {
      mesh      : getRackModel(`${this.line}_UPRIGHTS`, `upright numbered ${this.height}`),
      slots     : {},
      anchor    : 'crossmember-bottom',
      materials : this.material,
      offset    : this.config.foldBackType === 'full' ? { z: 0.1 } : {},
      ...sideTransform,
    }
  }

  createFullWBackStick(left: boolean): PartDefinition {
    const sideTransform = this.getSideTransform(left)

    return {
      mesh      : getRackModel(`CAVE_${this.line}`, `stick numbered ${this.height}`),
      slots     : {},
      anchor    : 'crossmember-bottom',
      materials : this.material,
      ...sideTransform,
    }
  }

  createShelfUpright(left: boolean): PartDefinition {
    const panelWidth = left ? this.config.leftPanelWidth : this.config.rightPanelWidth

    let panelOffset

    if (panelWidth === '70') {
      panelOffset = { y: 0.35, z: 0.1 } 
    } else if (panelWidth === '43') {
      panelOffset = { z: -0.1 } 
    } else {
      panelOffset = { y: -0.05, z: 0.1 } 
    }
    
    return {
      mesh        : getRackModel(`${this.line}_UPRIGHTS`, `upright numbered ${this.height}`),
      slots       : {},
      anchor      : 'crossmember-bottom',
      materials   : this.uprightMaterial,
      offset      : panelOffset,
      adjustments : [
        { type: 'rotate', amount: 90, axis: 'Y' },
        { type: 'flip', axis: 'Z' },
      ],
    }
  }

  createCableUpright(left: boolean): PartDefinition {
    return {
      mesh        : getRackModel(`${this.line}_UPRIGHTS`, `upright numbered ${this.height}`),
      slots       : {},
      anchor      : 'crossmember-bottom',
      materials   : this.uprightMaterial,
      adjustments : left ? [] : [{ type: 'rotate', amount: 180, axis: 'Y' }],
    }
  }

  protected getSideTransform(left: boolean): Partial<PartDefinition> {
    if (left) return {}
    
    return {
      adjustments    : [{ type: 'rotate', axis: 'Y', amount: 180 }],
      adjustmentType : AdjustOnlyVisual,
    }
  }
}